<mat-card class="example-card m-3 !sticky !top-0 !z-50">
  <mat-card-actions class="!flex !justify-between items-center gap-3 !p-3">
    <div class="!flex !gap-2 !items-center">
      <div
        mat-card-avatar
        class="!flex !justify-center !items-center !m-0"
        style="background-color: gray">
        <mat-icon class="mi-historico">history</mat-icon>
      </div>

      <h4 class="!m-0 !p-0">Registro Histórico</h4>
    </div>
    <div class="!flex !gap-3 items-center">
      <a [routerLink]="['/consulta']" class="!uppercase" mat-raised-button
        >Regresar</a
      >
      <a
        [queryParams]="{
          historicoEntrada: idTema + '/' + idEntrada,
          camposEncontrados
        }"
        [routerLink]="['/entrada/new/add']"
        class="!uppercase"
        color="warn"
        mat-flat-button>
        Actualizar entrada
      </a>
    </div>
  </mat-card-actions>
</mat-card>
<mat-card class="example-card m-3" *ngIf="historico">
  @for (item of historico; track $index) {
  <mat-card-content
    class="consulta-item !flex !justify-start !items-start !p-3 !m-0 !gap-3">
    <div>
      <mat-icon class="mi-item">bookmark</mat-icon>
    </div>

    <div class="w-full">
      <h4
        [ngClass]="{
          'histotico-active': item.active,
          inactive: !item.active
        }"
        class="!m-0 !w-full">
        {{ item.des }}
      </h4>
      <p class="!p-0 !m-0 subtitle-historico !w-full">{{ item.value }}</p>
    </div>
  </mat-card-content>
  }
</mat-card>

<mat-card class="example-card m-3">
  <mat-card-actions
    class="!flex !justify-between items-center gap-3 !p-3 !pb-0">
    <div class="!flex !gap-3">
      <div
        mat-card-avatar
        class="!flex !justify-center !items-center !m-0"
        style="background-color: gray">
        <mat-icon class="mi-historico">history</mat-icon>
      </div>
      <h4>Comentario Histórico</h4>
    </div>
  </mat-card-actions>
  <mat-card-content
    class="consulta-item !flex !justify-start !items-start !m-0 !gap-3 !pl-5 !pr-5 !pt-3">
    <mat-icon class="mi-item">chat</mat-icon>
    <p class="!p-0 !m-0 subtitle-historico">{{ comentarios }}</p>
  </mat-card-content>
</mat-card>
